import { BannerSection } from './BannerSection'
import { withBannerSection } from './withBannerSection'

const ConnectedBannerSection = withBannerSection(BannerSection)

export { ConnectedBannerSection as BannerSection }
